import { render, staticRenderFns } from "./rec_workcards_link.vue?vue&type=template&id=781b7939&scoped=true&"
import script from "./rec_workcards_link.vue?vue&type=script&lang=js&"
export * from "./rec_workcards_link.vue?vue&type=script&lang=js&"
import style0 from "./rec_workcards_link.vue?vue&type=style&index=0&id=781b7939&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781b7939",
  null
  
)

export default component.exports